import React from "react";
import ReactDOM from "react-dom";
import { applyMiddleware, createStore } from "redux";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

import promise from "redux-promise";
import multi from "redux-multi";
import thunk from "redux-thunk";

import AuthOrApp from "./main/authOrApp";
import reducers from "./main/reducers";
import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = applyMiddleware(multi, thunk, promise)(createStore)(reducers, devTools);
ReactDOM.render(
    <Provider store={store}>
        <AuthOrApp />
    </Provider>,
    document.getElementById("app")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

// registro do SW padrão do CRA continua para cache
if ("serviceWorker" in navigator && "PushManager" in window) {
    navigator.serviceWorker
        .register("/push-sw.js", { scope: "/push/" })
        .then((registration) => {
            console.log("Push SW registrado:", registration);
        })
        .catch((err) => console.error("Erro ao registrar push SW:", err));
}
